/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Caption_Style_TitleInputs */

const en_input_caption_style_title = /** @type {(inputs: Input_Caption_Style_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caption Style`)
};

const fr_input_caption_style_title = /** @type {(inputs: Input_Caption_Style_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style de Sous-titre`)
};

const de_input_caption_style_title = /** @type {(inputs: Input_Caption_Style_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildunterschriftenstil`)
};

const it_input_caption_style_title = /** @type {(inputs: Input_Caption_Style_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stile didascalia`)
};

const ru_input_caption_style_title = /** @type {(inputs: Input_Caption_Style_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стиль подписи`)
};

const es_input_caption_style_title = /** @type {(inputs: Input_Caption_Style_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilo de subtítulo`)
};

const zh_cn2_input_caption_style_title = /** @type {(inputs: Input_Caption_Style_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标题样式`)
};

const ja_input_caption_style_title = /** @type {(inputs: Input_Caption_Style_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプションスタイル`)
};

const hi_input_caption_style_title = /** @type {(inputs: Input_Caption_Style_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन शैली`)
};

const pt_pt2_input_caption_style_title = /** @type {(inputs: Input_Caption_Style_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilo da legenda`)
};

/**
* | output |
* | --- |
* | "Caption Style" |
*
* @param {Input_Caption_Style_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_caption_style_title = /** @type {((inputs?: Input_Caption_Style_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Caption_Style_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_caption_style_title(inputs)
	if (locale === "de") return de_input_caption_style_title(inputs)
	if (locale === "it") return it_input_caption_style_title(inputs)
	if (locale === "ru") return ru_input_caption_style_title(inputs)
	if (locale === "es") return es_input_caption_style_title(inputs)
	if (locale === "zh-CN") return zh_cn2_input_caption_style_title(inputs)
	if (locale === "ja") return ja_input_caption_style_title(inputs)
	if (locale === "hi") return hi_input_caption_style_title(inputs)
	if (locale === "pt-PT") return pt_pt2_input_caption_style_title(inputs)
	return en_input_caption_style_title(inputs)
});